import { ProductDetailsOverview } from '@/components/modules/ProductsDetailsOverview/components/ProductDetailsOverview';
import { useLoanApplicationMode } from '@/components/modules/ProductsDetailsOverview/hooks/useLoanApplicationMode';
import { APP_ROLES } from '@/config/config';
import { PermissionsConditionType } from '@/config/types';
import { usePermission } from '@/hooks/usePermission';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const OrderDetailsOverview = () => {
  // set special permissions
  const showClientData = usePermission({
    userTypes: [],
    roles: [APP_ROLES.MERCHANT, APP_ROLES.CHANNEL, APP_ROLES.AGENT],
    conditionType: PermissionsConditionType.OR,
  });

  const { getLoanApplicationModeByRole } = useLoanApplicationMode();

  const enableApplicationProcessing = usePermission({
    userTypes: [],
    roles: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN, APP_ROLES.LENDER],
    conditionType: PermissionsConditionType.OR,
  });

  const mode = getLoanApplicationModeByRole();

  return (
    <ProductDetailsOverview
      showClientData={showClientData}
      enableApplicationProcessing={enableApplicationProcessing}
      mode={mode}
    ></ProductDetailsOverview>
  );
};

export const OrderDetailsOverviewModule = withPermissionsModule(OrderDetailsOverview);
